import { createFileRoute } from '@tanstack/react-router'
import Footer from '../components/landing/Footer'
import "./legal.css"

export const Route = createFileRoute('/blog')({
  component: BlogPage,
})

function BlogPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Modulus Sell Blog</h1>
        
        <div className="legal-section">
          <h2>The Modern Retail Revolution</h2>
          <p className="legal-updated">Published by Modulus Team</p>
          
          <p>
            Retail is evolving. It's no longer just about waiting for customers to walk into your store. 
            It's about efficient operations and meeting your customers where they are—online.
          </p>

          <h3>Mastering Inventory Management</h3>
          <p>
            The heart of any successful retail business is knowing what you have and what you need. 
            Digital inventory tracking eliminates the guesswork of manual stocktaking. 
            By digitizing your stock, you prevent overstocking of slow-moving items and stockouts of your bestsellers, 
            directly impacting your bottom line.
          </p>

          <h3>The Power of Social Commerce</h3>
          <p>
            Social media platforms like Instagram and Facebook have become the new high streets. 
            However, managing orders through Direct Messages (DMs) is chaotic and unscalable. 
            Modulus Sell bridges this gap by providing a professional, instant e-commerce website linked to your inventory. 
            This allows you to showcase products on social media and redirect potential buyers to a secure checkout, 
            building trust and professional credibility.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
